(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("videoReviewerComponent", {
            controller: VideoReviewerComponent,
            bindings: {
                card: '<',
                hMapMode: '<',
                defaultLocation: '<',
                reviewers: '<',
                canReview: '<',
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/video-reviewer/video-reviewer.component.html'
        });

    VideoReviewerComponent.$inject = ['$scope', '$state', 'hUser', 'hFormsService', 'amsBus', 'interviewBankDataService', 'candidateNotesService', 'userPermissions'];

    function VideoReviewerComponent($scope, $state, hUser, hFormsService, amsBus, interviewBankDataService, candidateNotesService, userPermissions) {

        var self = this;
        self.data = {};
        self.data.questions = [];
        self.data.interviewStatus = '';
        self.STATUSES = QuestionBankAPI.STATUSES;
        self.reviewedAnswers = {};
        self.showReviews = [];
        self.data.evaluations = {};
        self.reviewers = [];

        var _AMSDataManager,
            _AMSActions,
            _AMSRenderHelper;

        if (amsBus.isAMSInitialized) {
            _AMSDataManager = amsBus._AMSDataManager;
            _AMSActions = amsBus._AMSActions;
            _AMSRenderHelper = amsBus._AMSRenderHelper;
            self.job = _AMSDataManager.job;
        }

        var goNext = function() {
            setTimeout(function(){
                $(".speedyx-arrow.go-right").click();
            }, 1);
        };

        var prepareState = function(candidate, location, toBucket) {
            var appInformation = _AMSDataManager.getCardsFromAppIds([candidate.id]);

            var appIdsGroup = [ [{'app_id':candidate.id, 'index':appInformation[candidate.id].index}] ];

            var fromState = {
                indices: [appInformation[candidate.id].index],
                bucket: appInformation[candidate.id].bucket,
                location: appInformation[candidate.id].location
            };

            var toState = {
                indices: [0],
                bucket: toBucket,
                location: location
            };

            return {
                appIds: appIdsGroup,
                fromState: [fromState],
                toState: toState
            }
        };

        self.passCandidate = function(candidate, location) {
            if (!self.skipDisabled && !self.buttonsDisabled) {

                var appInformation = _AMSDataManager.getCardsFromAppIds([candidate.id]);
                var appIdsGroup = [[{'app_id': candidate.id, 'index': appInformation[candidate.id].index}]];

                var fromState = [{
                    indices: [appInformation[candidate.id].index],
                    bucket: appInformation[candidate.id].bucket,
                    location: appInformation[candidate.id].location
                }];

                var to_location = appInformation[candidate.id].location;

                if (to_location == 'all') {
                    to_location = _AMSDataManager.getBucketFirstLocationId(AMSAPI.PASSED);
                }

                var toState = {
                    indices: [0],
                    bucket: AMSAPI.PASSED,
                    location: to_location
                };

                self.skipDisabled = true;
                self.buttonsDisabled = true;

                _AMSActions.handleAction(appIdsGroup, fromState, toState)
                    .then(function () {
                        self.card.bucket_id = toState.bucket;
                        // Cancel the interview from card in case of interview already scheduled
                        self.card.schedule_date = [];
                        goNext();
                    })
                    .finally(function () {
                        self.skipDisabled = false;
                        self.buttonsDisabled = false;
                    });
            }
        };

        self.getNextBucket = function (bucketId) {
            if (_AMSRenderHelper) {
                return _AMSRenderHelper.getNextBucket(bucketId);
            }
        };

        self.isCustom = function (bucketId) {
            if (_AMSDataManager) {
                return _AMSDataManager.data[bucketId].type === 'CUSTOM';
            }
        };

        self.getBucketWeight = function (bucketId) {
            if (_AMSDataManager && _AMSDataManager.data && _AMSDataManager.data[bucketId]) {
                return _AMSDataManager.data[bucketId].weight;
            }
            return false;
        };

        self.isBeforeOffer = function () {
            if (_AMSDataManager && _AMSDataManager.data) {
                var tempBucket = 0;
                if (_AMSDataManager.data[AMSAPI.OFFER]) {
                    tempBucket = AMSAPI.OFFER;
                } else if (_AMSDataManager.data[AMSAPI.ONBOARDING]) {
                    tempBucket = AMSAPI.ONBOARDING;
                } else if (_AMSDataManager.data[AMSAPI.HIRED]) {
                    tempBucket = AMSAPI.HIRED;
                }
                return self.getBucketWeight(self.card.bucket_id) < self.getBucketWeight(tempBucket);
            }
            return false;
        };

        self.isInSpecificColumn = function (bucketsIdsToCheck) {
            if (_AMSDataManager && _AMSDataManager.data) {
                for (var i in bucketsIdsToCheck) {
                    var bucketId = bucketsIdsToCheck[i];
                    if (self.getBucketWeight(bucketId) &&
                        self.getBucketWeight(self.card.bucket_id) === self.getBucketWeight(bucketId)) {
                        return true;
                    }
                }
            }
            return false;
        };

        self.showSkipButton = function () {
            return !self.isInSpecificColumn([self.card.AMSAPI.PASSED]) &&
                (
                    self.getBucketWeight(self.card.bucket_id) < 5000 ||
                    self.isInSpecificColumn([self.card.AMSAPI.RIGHT_TO_WORK, self.card.AMSAPI.KEESING])
                );
        };

        self.showMoveNextButton = function () {
            return !self.isInSpecificColumn([self.card.AMSAPI.PASSED]) &&
                (self.isBeforeOffer(self.getNextBucket(self.card.bucket_id)) || !self.hMapMode);
        };

        self.restoreCandidate = function(candidate, location) {
            if (!self.restoreDisabled && !self.buttonsDisabled) {
                var toLocation = location || AMSAPI.GENERIC_LOCATION;

                var state = prepareState(candidate, toLocation, AMSAPI.APPLICANTS);

                self.card.bucket_id = state.toState.bucket;

                self.restoreDisabled = true;
                self.buttonsDisabled = true;

                _AMSActions.handleAction(state.appIds, state.fromState, state.toState)
                    .then(function () {
                        self.card.bucket_id = state.toState.bucket;
                        goNext();
                    })
                    .finally(function () {
                        self.restoreDisabled = false;
                        self.buttonsDisabled = false;
                    });
            }
        };

        self.messageCandidate = function(candidate, location, toBucketId) {
            if (!self.moveNextDisabled && !self.buttonsDisabled) {
                var toLocation = location || AMSAPI.GENERIC_LOCATION;

                var state = prepareState(candidate, toLocation, String(toBucketId));

                self.card.bucket_id = state.toState.bucket;

                self.moveNextDisabled = true;
                self.buttonsDisabled = true;
                _AMSActions.onCardsSaved((appIdsGroup, fromStates, toState) => {
                    handler?.(toState);
                });

                _AMSActions.handleAction(state.appIds, state.fromState, state.toState).catch((err) => {
                    self.moveNextDisabled = false;
                    self.buttonsDisabled = false;
                })
            }
        };

        let handler = (toState) => {
            if (self.moveNextDisabled || self.buttonsDisabled) {
                HNotifications.show({
                    desc: $filter("translate")("Candidate has been moved to next step in the hiring process successfully"),
                    icon: "fa-check",
                    type: "success"
                });
                self.card.bucket_id = toState.bucket;
                self.moveNextDisabled = false;
                self.buttonsDisabled = false;
                goNext();
            }
        }

        var videoReviewerForm = hFormsService.getForm("videoReviewerForm");

        var remakeEvaluationsStructure = function () {
            for (var i in self.data.reviews) {
                var review = self.data.reviews[i];
                for (var j in review.answers_evaluations) {
                    var evaluation = review.answers_evaluations[j];
                    if (evaluation && evaluation.answer_id) {
                        self.data.evaluations[evaluation.answer_id] = self.data.evaluations[evaluation.answer_id] || [];
                        self.data.evaluations[evaluation.answer_id].push({
                            review: evaluation,
                            reviewer: review.interviewer_user
                        });
                        if (review.interviewer_user.id === hUser.data.user.id) {
                            var index = _.findIndex(self.data.questions, function (question) {
                                return question.answer.id === evaluation.answer_id;
                            });
                            self.reviewedAnswers[index] = 'success';
                        }
                    }
                }
            }
        };

        interviewBankDataService.on('reviewedSuccessfully', function (res, index, answerId, payload) {
            const reviewer = self.reviewers.find((item) => {
                return item.interviewer_user.id === hUser.data.user.id;
            });
            const profileImage = reviewer.interviewer_user?.profile_image || {};

            if (res) {
                if (res.interview) {
                    self.data.totalScore = res.interview.total_score;
                }

                if (res.evaluation && !isNaN(parseFloat(res.evaluation.total_score)) && res.interview && !isNaN(parseFloat(res.interview.total_score))) {
                    reviewer.total_score = res.evaluation.total_score;

                    if (self.reviewer && !isNaN(parseFloat(self.reviewer.total_score))) {
                        self.reviewer.total_score = res.evaluation.total_score;
                    }
                    for (let i in self.data.reviews) {
                        if (self.data.reviews[i].interviewer_user.id === hUser.data.user.id) {
                            self.data.reviews[i].total_score = res.evaluation.total_score;
                        }
                    }
                    prepareReviews(self.data.reviews);
                    self.card.video_interview.status = self.STATUSES.INTERVIEWED;
                    self.card.video_interview.reviewer = "CAN_NOT_REVIEW";
                    self.card.video_interview.total_score = res.interview.total_score;

                    var card = {};
                    card.application_id = self.card.application_id;
                    card.video_interview = self.card.video_interview;
                    card = _AMSDataManager.updateCard(card);
                    _AMSRenderHelper.invalidateCard(card);
                }
            }
            self.data.evaluations[answerId] = self.data.evaluations[answerId] || [];
            self.data.evaluations[answerId].push({
                review: payload,
                reviewer: {
                    id: hUser.data.user.id,
                    first_name: hUser.data.user.first_name,
                    last_name: hUser.data.user.last_name,
                    profile_image: profileImage
                }
            });
            self.reviewedAnswers[index] = 'success';
            var tempIndex = index + 1;
            if (tempIndex < self.data.questions.length) {
                self.onSelectQuestion(tempIndex);
            }
            $scope.$digest();
        });

        interviewBankDataService.on('overAllReviewedSuccessfully', function (res) {
            if (res) {
                if (res.interview) {
                    self.data.totalScore = res.interview.total_score;
                }

                if (res.evaluation && !isNaN(parseFloat(res.evaluation.total_score)) && res.interview && !isNaN(parseFloat(res.interview.total_score))) {
                    var reviewer = _.find(self.reviewers, function (item) {
                        return item.interviewer_user.id === hUser.data.user.id;
                    });
                    reviewer.total_score = res.evaluation.total_score;

                    if (self.reviewer) {
                        self.reviewer.total_score = res.evaluation.total_score;
                    }
                    for (let i in self.data.reviews) {
                        if (self.data.reviews[i].interviewer_user.id === hUser.data.user.id) {
                            self.data.reviews[i].total_score = res.evaluation.total_score;
                        }
                    }
                    prepareReviews(self.data.reviews);
                    self.card.video_interview.status = self.STATUSES.INTERVIEWED;
                    self.card.video_interview.reviewer = "CAN_NOT_REVIEW";
                    self.card.video_interview.total_score = res.interview.total_score;

                    var card = {};
                    card.application_id = self.card.application_id;
                    card.video_interview = self.card.video_interview;
                    card = _AMSDataManager.updateCard(card);
                    _AMSRenderHelper.invalidateCard(card);
                    _AMSRenderHelper.renderCards();
                }
                $scope.$digest();
            }
        });

        interviewBankDataService.on('failedToReview', function (index) {
            self.reviewedAnswers[index] = 'failure';
            $scope.$digest();
        });

        const prepareReviews = (reviews) => {
            self.hasReviews = false;
            let reviewersTooltipText = '';
            self.finishedReviewersCount = 0;
            let reviewers = [...reviews];
            reviewers.sort((a, b) => {
                const aHasScore = a.total_score ? 1 : 0;
                const bHasScore = b.total_score ? 1 : 0;
                return bHasScore - aHasScore;
            });
            for (let i in reviewers) {
                reviewersTooltipText += `${reviewers[i].interviewer_user.first_name} ${reviewers[i].interviewer_user.last_name}: `;
                if (reviewers[i].total_score) {
                    self.hasReviews = true;
                    reviewersTooltipText += `<b>${reviewers[i].total_score}</b>`;
                    self.finishedReviewersCount++;
                } else {
                    reviewersTooltipText += $filter('translate')('No review yet');
                }
                reviewersTooltipText += '<br/>';
            }
            self.reviewersTooltipText = reviewersTooltipText;
        }

        self.$onInit = function () {
            self.videoReviewerForm = new videoReviewerForm($scope, "video-reviewer-form");
            self.reviewer = _.find(self.reviewers, function (item) {
                return item.interviewer_user.id === hUser.data.user.id;
            });
            self.loading = true;
            interviewBankDataService.getApplicantInterview(self.card.brand_id, interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW, self.card.application_id)
                .then(function (res) {
                    self.loading = false;
                    if (res && !_.isEmpty(res)) {
                        var data = angular.copy(res);
                        self.data.questions = data.questions;
                        self.data.totalScore = null;
                        self.data.interviewStatus = data.status;
                        self.data.interviewId = data.id;
                        self.data.reviews = data.evaluations;
                        prepareReviews(self.data.reviews);
                        self.data.totalScore = data.total_score;
                        remakeEvaluationsStructure();
                        if (data.template) {
                            self.data.scoringMode = data.template.scoring_mode;
                        }
                        var tempData = {
                            brandId: self.card.brand_id,
                            applicantId: self.card.application_id,
                            questions: data.questions,
                            interviewId: data.id
                        };
                        self.videoReviewerForm.load(tempData);
                        self.onSelectQuestion(0);
                    }
                })
                .catch(function (err) {
                    self.loading = false;
                    console.error(err);
                });
            prepareNotesSection();
        };

        self.addReview = function () {
            if (self.data.tempTotalScore > 0) {
                var param = {
                    total_score: self.data.tempTotalScore,
                };

                self.evaluating = true;
                interviewBankDataService.postOverAllScore(self.card.brand_id, interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW, self.card.application_id, self.data.interviewId, param)
                    .then(function (res) {
                        if (res && res.interview) {
                            self.data.totalScore = res.interview.total_score;
                            prepareReviews(self.data.reviews);
                        }
                    })
                    .catch(function (err) {
                        self.data.tempTotalScore = 0;
                        hAlert($filter('translate')('Video screening'), $filter('translate')('Error while submitting review'));
                        console.error(err);
                    })
                    .finally(function () {
                        self.evaluating = false;
                        $scope.$digest();
                    });
            }
        };

        const pauseQuestionVideoIfPlaying = (index) => {
            const questionVideoElement = document.getElementById(`section-video-${index}`);
            if (questionVideoElement && !questionVideoElement.paused) {
                questionVideoElement.pause();
            }
            if (document.pictureInPictureElement) {
                document.exitPictureInPicture()
                    .catch((error) => console.error("Error exiting PiP:", error));
            }
        }

        self.onSelectQuestion = (index) => {
            if (self.selectedQuestionIndex === index) {
                return;
            }
            pauseQuestionVideoIfPlaying(self.selectedQuestionIndex);
            self.selectedQuestionIndex = index;
            self.videoReviewerForm.onSelectQuestion(self.data.questions[index].id, index)
        }

        const prepareNotesSection = async () => {
            self.loadingNotes = true;
            let promises = {
                notes: candidateNotesService.getCandidateNotes(getBrandId(), self.card.candidate_id),
                brands: prepareBrandsData(),
                userMedia: UserAPI.getUserBasicMedia(),
            }
            const { notes, brands, userMedia } = await $q.all(promises);
            self.notes = notes;
            const { sourceBrand, activeBrand } = brands;
            await prepareAddedByLocationList(notes, sourceBrand, activeBrand);
            self.hasManageNotesPermission = !!self.addedByLocations.length;
            self.user = {
                id: hUser.data.user.id,
                first_name: hUser.data.user.first_name,
                last_name: hUser.data.user.last_name,
                image_uuid: userMedia['user_profile']['uuid']
            };
            self.loadingNotes = false;
            $scope.$digest();
        }

        const getBrandId = () => {
            return (self.card.contextBrand && self.card.contextBrand.id) || (self.card.sourceParentBrand && self.card.sourceParentBrand.id)
        };

        const prepareBrandsData = () => {
            const deferred = $q.defer();
            let sourceBrand = self.card.sourceParentBrand;
            let activeBrand = self.card.contextBrand;

            const brandsDataPromises = {};
            if (sourceBrand && activeBrand.id !== sourceBrand.id && (!sourceBrand.name || sourceBrand.name === '')) {
                brandsDataPromises[sourceBrand.id] = candidateNotesService.getBrandBasicInfo(sourceBrand.id);
            }
            if (activeBrand && (!activeBrand.name || activeBrand.name === '')) {
                brandsDataPromises[activeBrand.id] = candidateNotesService.getBrandBasicInfo(activeBrand.id);
            }

            $q.all(brandsDataPromises)
                .then((res) => {
                    if (sourceBrand && res[sourceBrand.id]) {
                        sourceBrand = res[sourceBrand.id];
                    }

                    if (activeBrand && res[activeBrand.id]) {
                        activeBrand = res[activeBrand.id];
                    }
                    deferred.resolve({ sourceBrand, activeBrand });
                })
                .catch((err) => {
                    deferred.reject(err);
                });
            return deferred.promise;
        };

        const pushToAddedByLocationList = (location) => {
            const found = self.addedByLocations.find(item => item.id === location.id);
            if (!found) {
                self.addedByLocations.push({
                    id: location.id,
                    type: location.type,
                    name: location.name
                });
            }
            self.data.location = self.addedByLocations[0];
        };

        const hasManageNotesPermissions = (brandsIds) => {
            const deferred = $q.defer();
            brandsIds = Array.isArray(brandsIds)? brandsIds: [brandsIds];

            userPermissions.getBrandPolicy(brandsIds)
                .then((policyParser) => {
                    let hasPermission = false;
                    for (let i in brandsIds) {
                        hasPermission = hasPermission || policyParser.clone().brand(brandsIds[i]).has(userPermissions.PERMISSIONS.MANAGE_CANDIDATE_NOTES);
                    }
                    deferred.resolve(hasPermission);
                })
                .catch((err) => {
                    console.error(err);
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        const prepareAddedByLocationList = (notes, sourceBrand, activeBrand) => {
            const deferred = $q.defer();

            self.addedByLocations = [];
            const permissionPromises = {};

            for (let i in notes) {
                permissionPromises[notes[i].brand.id] = hasManageNotesPermissions(notes[i].brand.id);
            }

            if (sourceBrand && activeBrand.id !== sourceBrand.id) {
                permissionPromises[sourceBrand.id] = hasManageNotesPermissions(sourceBrand.id);
            }

            if (activeBrand) {
                if (activeBrand.isGP || (activeBrand.type && activeBrand.type.indexOf("GP-") === 0)) {
                    permissionPromises[activeBrand.id] = hasManageNotesPermissions(activeBrand.id);
                } else {
                    const brandsListIds = hUser.getUser().brands_list.map(item => item.id);
                    permissionPromises[activeBrand.id] = hasManageNotesPermissions(brandsListIds);
                }
            }

            $q.all(permissionPromises)
                .then((res) => {
                    if (res?.[activeBrand.id]) {
                        pushToAddedByLocationList(activeBrand);
                    }
                    for (let i in notes) {
                        if (res?.[notes[i].brand.id]) {
                            pushToAddedByLocationList(notes[i].brand);
                        }
                    }
                    if (sourceBrand && res?.[sourceBrand.id]) {
                        pushToAddedByLocationList(sourceBrand);
                    }
                    deferred.resolve();
                })
                .catch((err) => {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        const onNoteAddedHandler = async (notes) => {
            notes = notes || [];
            self.notes = notes.concat(self.notes || []);
            let { sourceBrand, activeBrand } = await prepareBrandsData();
            await prepareAddedByLocationList(self.notes, sourceBrand, activeBrand);
            self.data.location = self.addedByLocations[0];
            self.data.note = '';
            $scope.$digest();
        };

        let onNoteAddedEvent = candidateNotesService.on(candidateNotesService.EVENTS.ON_NOTE_CREATED, onNoteAddedHandler);

        self.addNote = () => {
            if (self.hasManageNotesPermission && self.data.location && self.data.note && self.data.note !== "") {
                self.addingNote = true;

                let params = {
                    comment: self.data.note,
                    candidate_ids: [self.card.candidate_id]
                };
                candidateNotesService
                    .createCandidateNote(self.data.location.id, params)
                    .then((notes) => {
                        self.addingNote = false;
                    })
                    .catch((err) => {
                        console.error(err);
                        self.addingNote = false;
                    });
            }
        };

        self.$onDestroy = () => {
            candidateNotesService.off(onNoteAddedEvent);
            handler = null;
        };
    }
})();
